export default function generateShareForm(player) {
    const localize = player.localize?.bind(player);
    const template = `<h2 id="mediasite-player__search-header">${localize('Share Presentation')}</h2>
<form>
    <p><fieldset class="time-fieldset"><legend class="vjs-hidden">${localize('Time')}</legend><input type="checkbox" name="timeCheckbox" aria-label="${localize('Start Time')}"/><span>${localize('Time at')}</span><input name="time" pattern="^\\d\\d:[0-5]\\d:[0-5]\\d$" aria-label="${localize('Time')}" /></fieldset></p>
    <p class="share-presentation-holder">
        <textarea id="share-presentation-link" type="text" name="share-link" readonly="readonly"></textarea>
        <a id="share-copy-link" class="player-primary-link"/>${localize('Copy')}</a>
    </p>
</form>`;

    const container = document.createElement('div');
    container.innerHTML = template;
    return container;
}